<template>
<div class="md:grid md:grid-cols-3">
    <Card v-for="trophy in trophies" :key="trophy.id" :trophy="trophy"
        :isHigh="!isolated"
        :isMedium="isolated"
        />
</div>
</template>

<script>
import Card from '@/components/Home/KPIS/Cards/Format-1.vue'

export default {
    components: {
        Card
    },
    props: {
        isolated: {
            type: Boolean,
            required: false
        },
        trophies: {
            type: Array,
            required: true
        }
    }
}
</script>